module.exports = __webpack_public_path__ + "static/media/steady-study-qr-table.4aa06e83.png";